import React, { useState, useEffect } from "react";
import { firestore } from "./firebase/firebase";
import { useAuth } from "./firebase/AuthContext";
import DoneIcon from '@mui/icons-material/Done';
import { Card, CardContent } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import {  Link, useHistory} from "react-router-dom";
import PlansButton from "./paymentLanding";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rounded: {
    borderRadius: "10px",
    border: "none",
  },
  container: {
    backgroundColor: "#F9FAFB",
    padding: "8%",
  },
  image: {
    width: "100%",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
  },
  title: {
    fontFamily: "Inter",
    fontSize: "35px",
    fontWeight: "bold",
  },
  subtitle: {
    fontFamily: "Inter",
    color: "#6B7280",
    fontSize: "18px",
  },
}));

function Gateway() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const [stripeId, setStripeId] = useState("");
  const { currentUser, signup } = useAuth();
  const [isLoading, setIsLoading] = useState(false);





  const handleClose = () => {
      return null
  };

  useEffect(() => {
    setOpen(true);
  }, []);

  const handleOpenTwo = () => {
    if(!currentUser){
      history.push("/")
    }else{
      
      const handleCustomerPortalClick = async () => {
        setIsLoading(true);
      
        try {
          const response = await fetch(`${process.env.REACT_APP_PORTAL}/create-portal-link`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              returnUrl: window.location.origin,
              locale: 'auto',
              userId: `${stripeId}`
            }),
          });
      
          const { url } = await response.json();
          window.location.assign(url);
        } catch (error) {
          console.error(error);
        } finally {
          setIsLoading(false);
        }
      };

      handleCustomerPortalClick();

    }
    
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#F5F5F5' }}>
  <Card style={{ maxWidth: '400px', backgroundColor: '#FFFFFF', boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)', borderRadius: '8px', padding: '32px' }}>
    <CardContent style={{ textAlign: 'center' }}>
      <h4 style={{ fontFamily: 'Inter', fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>Standard</h4>
      <h5 style={{ fontFamily: 'Inter', color: '#6B7280', fontSize: '15px', marginBottom: '24px' }}>Get full access.</h5>
      <h3 style={{ fontFamily: 'Inter', fontSize: '36px', fontWeight: 'bold', marginBottom: '16px' }}>$20<span style={{ fontFamily: 'Inter', fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color:'grey'}}>/month</span></h3>
      <ul style={{ textAlign: 'left', marginBottom: '24px', listStyleType: 'none', whiteSpace: 'nowrap' }}>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>Unlimited mapping</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>Save your maps</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>No setup, monthly, or hidden fees</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>1000 x AI generated suggestions</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>250 x AI generated summaries</li>
      </ul>
      <PlansButton /*sub={handleSummariesChange}*/ />
    </CardContent>
  </Card>
</div>

  );
}

export default Gateway;

  